<template>
      
      <!-- Begin page -->
      <div id="wrapper">
            
            <!-- Top Bar Start -->
            <topbar></topbar>
            <!-- Top Bar End -->
            
            
            <!-- ========== Left Sidebar Start ========== -->
            
            <!-- Left Sidebar End -->
            <left></left>
            
            
            <!-- ============================================================== -->
            <!-- Start right Content here -->
            <!-- ============================================================== -->
            <div class="content-page">
                  <!-- Start content -->
                  <div class="content">
                        <div class="container-fluid">
                              
                              <div class="row">
                                    <div class="col-12">
                                          <div class="page-title-box">
                                                <h4 class="page-title float-left">我的主页</h4>
                                                
                                                <ol class="breadcrumb float-right">
                                                      <li class="breadcrumb-item"><a href="#">CPWM</a></li>
                                                      <li class="breadcrumb-item active">我的主页</li>
                                                </ol>
                                                
                                                <div class="clearfix"></div>
                                          </div>
                                    </div>
                              </div>
                              <!-- end row -->
                              
                              
                              <div class="row">
                                    <div class="col-md-6" >
                                          <div class="card-box">
                                                
                                                
                                                <ul class="nav nav-tabs">
                                                      <li class="nav-item">
                                                            <a aria-expanded="true" class="nav-link active"
                                                               data-toggle="tab" href="#home">
                                                                  修改密码
                                                            </a>
                                                      </li>
                                                </ul>
                                                <div class="tab-content">
                                                      <div class="tab-pane fade show active" id="home">
                                                            <!--start-->
                                                            <div class="">
                                                                  <p class="mb-1 mt-4 font-weight-bold">当前密码</p>
                                                                  <input class="form-control" name="country"
                                                                         type="text"
                                                                         v-model="password">
                                                            </div>
                                                            <div class="">
                                                                  <p class="mb-1 mt-4 font-weight-bold">新密码</p>
                                                                  <input class="form-control" name="country"
                                                                         type="text"
                                                                         v-model="newpassword1">
                                                            </div>
                                                            <div class="">
                                                                  <p class="mb-1 mt-4 font-weight-bold">再次输入</p>
                                                                  <input class="form-control" name="country"
                                                                         type="text"
                                                                         v-model="newpassword2">
                                                            </div>
                                                            <div style="width: 100%;float:left;padding:20px;text-align: right;">
                                                                  <button type="submit" style="margin: 0 auto;" class="btn btn-gradient btn-rounded waves-light waves-effect w-md"  v-on:click="edit">确认</button>
                                                            </div>
                                                            <div style="clear: both"></div>
                                                            
                                                            <!--over-->
                                                      </div>
                                                
                                                
                                                </div>
                                          </div>
                                    </div> <!-- end col -->
                                    
                                    <!-- end col -->
                              </div>
                              <!-- end row -->
                        
                        
                        </div> <!-- container -->
                  
                  </div> <!-- content -->
      
                  <!--footer-->
                  
                 
            </div>
            
            
            <!-- ============================================================== -->
            <!-- End Right content here -->
            <!-- ============================================================== -->
      
      
      </div>
      <!-- END wrapper -->


</template>

<script>
      import topbar from './topbar';
      import left from './left';

      export default {
            name: 'main',
            components: {topbar, left},
            data() {
                  return {
                        password:this.password,
                        newpassword1:this.newpassword1,
                        newpassword2:this.newpassword2,
                  }
            },
            mounted() {
            },
            methods: {
                  
                  edit: function () {
                        let data = {
                              password:this.password,
                              newpassword1:this.newpassword1,
                              newpassword2:this.newpassword2,
                        }
                        this.$axios({
                              method: 'post',
                              url: '/api/member2/password',
                              data: data,
                              headers: {
                                    membertoken: localStorage.getItem('membertoken')
                              }
                        }).then(function OnSuccess(response) {
                              if (response.data.code == 0) {
                                    swal(
                                          {
                                                title: response.data.msg,
                                                text: '',
                                                type: 'success',
                                                confirmButtonColor: '#4fa7f3',
                                          }
                                    )
                              } else {
                                    swal(
                                          {
                                                title: response.data.msg,
                                                text: '',
                                                type: 'error',
                                                confirmButtonColor: '#4fa7f3',
                                          }
                                    )
                              }
                    

                        }.bind(this)).catch(function OnError() {

                        })
                  },
                
                  goto: function (url) {
                        //this.$router.push({path:url});
                        window.location.href = "/member2/#" + url;
                  },
                  
                  //method over

            }
            //mounted over


      }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
      .zx {
            width: 100%;
      }
      
      .zx li {
            width: 100%;
            float: left
      }
      
      .msglist li {
            width: 50%;
            float: left;
            line-height: 4rem;
      }
      
      .msglist {
            width: 100%;
            float: left;
            border-bottom: 1px dashed #cccccc
      }
      
      .msglistright {
            text-align: right;
      }
      
      .inputself {
            width: 49%;
            margin-right: 1%;
            float: left
      }
      
      .tanchuang {
            border: 1px solid #0000ff;
            top: 30%;
            position: fixed;
            width: 30%;
            left: 35%;
            background-color: #ffffff;
            padding: 1%;
            z-index: 100;
      }
      
      .tanchuang h2 {
            font-size: 16px;
            border-bottom: 1px dashed #8c8c8c;
            line-height: 42px;
      }
      
      .tanchuang ul {
            margin: 20px;
      }
      
      .tanchuang li {
            line-height: 32px;
            text-align: center;
            width: 100%;
            float: left;
      }
      
      .tanchuang .pass {
            height: 22px;
      }
      
      .tanchuang .buttonclass {
            margin: 0 30px;
            padding: 0 10px;
      }
</style>



// WEBPACK FOOTER //
// src/components/password.vue